import './Main.scss';

import Flickity from './General/SliderInit';

// Make Flickity global (used for events)
window.Flickity = Flickity;
